"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var selector_js_1 = require("./selector.js");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var cmpts;
        (function (cmpts) {
            var selector;
            (function (selector) {
                var list;
                (function (list) {
                    /**
                     * Move items between two list. Can only handle string type for now.
                     */
                    var ListSelector = /** @class */ (function (_super) {
                        __extends(ListSelector, _super);
                        function ListSelector() {
                            return _super !== null && _super.apply(this, arguments) || this;
                        }
                        return ListSelector;
                    }(selector_js_1["default"].Selector));
                    list.ListSelector = ListSelector;
                })(list = selector.list || (selector.list = {}));
            })(selector = cmpts.selector || (cmpts.selector = {}));
        })(cmpts = r6.cmpts || (r6.cmpts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.cmpts.selector.list;
//# sourceMappingURL=list-selector.js.map


// WEBPACK FOOTER //
// ./app/components/list-selector/app/js/logic/list-selector.js